import * as queryString from 'query-string';

function ConserveParameters(importantParams) {
  function modifyPath(path) {
    const currentParams = queryString.parse(window.location.search);

    const paramList = {};
    let paramsToAdd = false;

    importantParams.forEach((param) => {
      if (currentParams[param]) {
        if (!path.match(`(\\?|&)${param}=`)) {
          paramList[param] = currentParams[param];
          paramsToAdd = true;
        }
      }
    });

    if (paramsToAdd) {
      path += path.indexOf('?') === -1 ? '?' : '&';
      path += queryString.stringify(paramList);
    }

    return path;
  }

  const oldPushState = window.history.pushState;
  const oldReplaceState = window.history.replaceState;

  window.history.pushState = function newPushState(...args) {
    args[2] = modifyPath(args[2]);
    oldPushState.apply(this, args);
  };

  window.history.replaceState = function newReplaceState(...args) {
    args[2] = modifyPath(args[2]);
    oldReplaceState.apply(this, args);
  };
}

export default ConserveParameters;



// WEBPACK FOOTER //
// ./helpers/conserve-parameters.js